 
<template>
  <div>
    <div class="search-from">
      <el-form
        ref="searchForm"
        :model="searchForm"
        :inline="true"
        style="text-align: left"
      >
        <el-form-item>
          <el-input
            v-model="searchForm.goodsCode"
            placeholder="商品基库ID"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="searchForm.goodsName"
            placeholder="产品名称"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="searchForm.approvalNumber"
            placeholder="批准文号"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="searchForm.factory"
            placeholder="生产厂家"
            clearable
            maxlength="20"
            size="small"
            style="width: 120px"
          />
        </el-form-item>

        <!-- <el-form-item>
          <el-select
            size="mini"
            v-model="searchForm.goodsType"
            placeholder="商品类型"
            style="width: 120px"
          >
            <el-option
              v-for="item in goodsTypeList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <goods-three-class
          ref="three-class"
          :formTool="searchForm"
          :isShowLable="false"
          :lableText="'商品分类'"
          :placeholderText="'商品分类'"
          :styleLable="'width:130px;margin-right:10px;'"
        ></goods-three-class>

        <el-form-item>
          <el-select
            size="mini"
            v-model="searchForm.status"
            placeholder="审核结果"
            style="width: 120px"
          >
            <el-option
              v-for="item in statusList"
              :label="item.name"
              :value="item.value"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="getList(1)"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="reset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="content">
      <myTable
        :table-data="tableData"
        :index="index"
        :selection="false"
        :page="page"
        :showpage="true"
        :operation="false"
        v-loading="loading"
        :table-option.sync="tableOption"
        @page-change="getList"
     
        :expand="false"
      >
        <template slot="status" slot-scope="scope">
          <span v-if="scope.row.status == 'PUTAWAY'"> 上架 </span>
          <span v-if="scope.row.status == 'SOLDOUT'"> 下架 </span>
          <span v-if="scope.row.status == 'AWAIT'"> 待审核 </span>
          <span v-if="scope.row.status == 'ALREADY'"> 已审核 </span>
          <span v-if="scope.row.status == 'FAIL'"> 审核失败 </span><!--  -->
        </template>

        <template slot="concatName" slot-scope="scope">
          <span v-if="scope.row.concatName">
            {{ scope.row.concatName }}  
          </span>
           <span v-if="scope.row.concatPhone">
              && {{ scope.row.concatPhone }}
          </span>
        </template>
          <!-- goodsType -->
        <template slot="goodsType" slot-scope="scope">
          <span v-if="scope.row.goodsType == 'DRUG'"> 药品 </span>
          <span v-if="scope.row.goodsType == 'FOOD'"> 食品 </span>
          <span v-if="scope.row.goodsType == 'MADI'"> 医疗器械 </span>
          <span v-if="scope.row.goodsType == 'TCMDP'"> 中药饮片 </span>
          <span v-if="scope.row.goodsType == 'OTHER'"> 其他 </span>

          <span
            v-if="
              scope.row.goodsType != 'DRUG' &&
              scope.row.goodsType != 'FOOD' &&
              scope.row.goodsType != 'MADI' &&
              scope.row.goodsType != 'TCMDP' &&
              scope.row.goodsType != 'OTHER'
            "
          >
            {{ scope.row.goodsType }}
          </span>
        </template>

        <template slot="operation" slot-scope="scope" fixed="right">
          <el-link
            type="primary"
            :underline="false"
            @click="checkDetails(scope.row)"
            style="margin-right: 10px"
          >
            查看
          </el-link>
        </template>
      </myTable>
    </div>
  </div>
</template>
<script>
import myTable from "@/components/myTable";
import avater from "/public/img/default.png";
import { queryShopPage } from "@/api/goodsManage/baseDepot";
import getComList from "@/utils/getComList";
import GoodsThreeClass from "@/components/goodsThreeClass";

export default {
  components: { myTable, GoodsThreeClass },
  props: {},
  data() {
    return {
      loading: false,
      avater: avater,
      searchForm: {
        goodsOneClassId: "",
        goodsTwoClassId: "",
        goodsThreeClassId: "",
      },
      tableData: [],
      goodsTypeList: [],
      operation: false,
      selection: true,
      index: false,

      statusList: [
        { value: "PUTAWAY", name: " 上架", id: 1 },
        { value: "SOLDOUT", name: "下架", id: 2 },
        { value: "AWAIT", name: "待审核", id: 3 },
        { value: "ALREADY", name: "已审核", id: 4 },
        { value: "FAIL", name: "审核失败", id: 5 },
      ],
      tableOption: [
        { label: "店铺信息", prop: "shopName", width: 220 },
        {
          label: "运营人员&联系方式",
          prop: "concatName",
          slot: true,
          width: 200,
        },
        { label: "产品名称", prop: "goodsName", width: 160 },
        { label: "批准文号", prop: "approvalNumber", width: 160 },
        { label: "生产厂家", prop: "factory", width: 200 },
        { label: "商品类型", prop: "goodsType", slot: true },
        { label: "审核人", prop: "checkName" },
        { label: "审核结果", prop: "status", slot: true },
        { label: "审核时间", prop: "checkingTime", width: 160 },
        { label: "基库ID", prop: "goodsCode", width: 140 },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 100,
          fixed: "right",
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      isReport: true,
    };
  },
  filters: {},
  created() {},
  mounted() {
    this.typeList();
    this.getList();
  },
  methods: {
    async typeList() {
      this.goodsTypeList = await getComList.goodsType; //商品类型
    },
 
    getList(current) {
      const params = Object.assign({}, this.searchForm);
      if (current) {
        params.current = 1;
      } else {
        params.current = this.page.current;
      }
      params.size = this.page.size;
      queryShopPage(params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },
    /**
     * @description: checkDetails 查看商品详情
     * @return {*}
     */
    checkDetails(row) {
      // console.log(row,'---row')
      this.$router.push(
          `./goodsManage-baseDepot-details?pageType=4&id=${row.id}&status=${row.status}` 
      );
      // this.goBaseDepotPage(`./goodsManage-baseDepot-details?pageType=4&&id=${row.id}&status=${row.status}`)
    },

    goBaseDepotPage( pathUrl ){
      let routeData = this.$router.resolve({
          path: pathUrl,
          query: {},
          params: {}
      })
      window.open(routeData.href, '_blank')
    },
    reset() {
      this.page.current = 1;
      this.searchForm = {};
      this.$refs["three-class"].resetForm();
      this.getList(1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("./styles/index.scss");
</style>